import './Icon_Alert_Triangle.css';

function Icon_Alert_Triangle() {
  return (
    <div className='icon-container-alert-triangle'>
      <svg viewBox="0 0 24 24" className="responsive-svg-alert-triangle">
        <path d="m21.73 18-8-14a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
        <path d="M12 9v4"/>
        <path d="m12 17 .01 0"/>
      </svg>
    </div>
  );
}

export default Icon_Alert_Triangle;